import { createColumn, defaultColumns, relationField } from '../_defaults/columns'

export const columns = [
  createColumn({
    label: 'Company',
    field: 'companyId',
    ...relationField({
      props: {
        config: {
          params: {}
        }
      },
      validation: {
        required: true
      },
      type: 'one',
      localKey: 'companyId',
      fk: 'companyId',
      namespace: 'company',
      filterIs: 'text-filter'
    })
  }),
  createColumn({
    label: 'supplyProvideService',
    field: 'supplyProvideServiceId',
    // displayValue: row => {
    //   return `${row.division.name}`
    // },
    ...relationField({
      props: {
        config: {
          params: {}
        }
      },
      validation: {
        required: true
      },
      type: 'one',
      localKey: 'supplyProvideServiceId',
      fk: 'supplyProvideServiceId',
      namespace: 'supplyProvideService',
      filterIs: 'text-filter'
    })
  })
].concat(defaultColumns)
